/**
 * フッターコンポーネント
 * アプリケーションの下部に表示される著作権情報、ライセンス情報などを表示
 */
import React, { useEffect, useState } from "react";
import { useAtom } from "jotai/index";

// ルートパスからのインポート
import "~/css/Footer.css";
import { T2SEngineAtom, currentSpeakerAtom, currentVRMAtom, fontSizeAtom } from "~/Atom";
import { appVersion, t2SEngines } from "~/Commons";
import { useTranslation } from "react-i18next";

/**
 * フッターコンポーネント
 * バージョン情報、ライセンス情報、免責事項を表示する
 */
const Footer: React.FC = () => {
  // グローバル状態（Jotai）
  const [currentSpeaker] = useAtom(currentSpeakerAtom);
  const [currentVRM] = useAtom(currentVRMAtom);
  const [T2SEngine] = useAtom(T2SEngineAtom);
  const [selectedSize] = useAtom(fontSizeAtom);
  const { t } = useTranslation();

  // 免責事項
  const disclaimer = t("disclaimer");

  // ローカル状態
  const [licenseText, setLicenseText] = useState<string>("");

  /**
   * 音声合成エンジンに基づいてライセンステキストを生成する
   */
  const generateLicenseText = (): string => {
    if (!currentVRM || currentSpeaker.Id === null) {
      return "";
    }

    switch (T2SEngine) {
      case t2SEngines.voicevox:
        return `${t2SEngines.voicevox}: ${currentSpeaker.Name} (${currentSpeaker.Style})`;

      case t2SEngines.openai:
        return `${t2SEngines.openai}: ${currentSpeaker.Name} (${currentSpeaker.Style})`;

      case t2SEngines.aivisSpeech:
        return `${t2SEngines.aivisSpeech}: ${currentSpeaker.Name} (${currentSpeaker.Style})`;

      default:
        return "";
    }
  };

  /**
   * 依存状態が変わるたびにライセンステキストを更新し、イベントも発火
   */
  useEffect(() => {
    const newLicenseText = generateLicenseText();
    setLicenseText(newLicenseText);
    window.dispatchEvent(
      new CustomEvent("aiConcierge:licenseTextUpdated", {
        detail: { licenseText: newLicenseText, currentVRM },
      })
    );
  }, [currentSpeaker, currentVRM, T2SEngine]);

  return (
    <footer className={`footer ${selectedSize}`}>
      <p>Ver.{appVersion}</p>
      <p>{licenseText}</p>
      <p>{disclaimer}</p>
    </footer>
  );
};

export default Footer;
